import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("stagvault_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.method === "post" && /\/billing\/(create-checkout-session|upgrade)/.test(config.url || "")) {
    // Rewardful attribution — attach synchronously so every checkout caller carries the referral.
    const referral = (typeof window !== "undefined" && window.Rewardful && window.Rewardful.referral) || null;
    if (referral && !config.data?.rewardful_referral) config.data = { ...(config.data || {}), rewardful_referral: referral };
    // Lazy import avoids a circular dependency (analytics.js imports api).
    import("./analytics").then(({ trackEvent, attribution, hasConsent }) => {
      const plan = config.data?.plan || "lifetime";
      const checkout_provider = String(plan).startsWith("track:") ? "shopify" : "stripe";
      // One checkout start per product per 30 min tab-session — repeated clicks don't inflate the funnel.
      const dedupeKey = `sv_checkout_started:${plan}`;
      const last = Number(sessionStorage.getItem(dedupeKey) || 0);
      if (Date.now() - last > 30 * 60 * 1000) {
        sessionStorage.setItem(dedupeKey, String(Date.now()));
        trackEvent("CheckoutStarted", { plan, content_name: plan, currency: "GBP", referred: !!referral, checkout_provider, affiliate_token: referral || undefined,
          utm_source: config.data?.utm_source, utm_medium: config.data?.utm_medium, utm_campaign: config.data?.utm_campaign });
      }
      config.data = { ...(config.data || {}), attribution: { ...attribution(), consent: hasConsent(), page_url: window.location.href } };
    }).catch(() => {});
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
